import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "b-table-header",
  wrap: ""
}
const _hoisted_2 = { class: "vstack gap-2" }
const _hoisted_3 = { class: "hstack" }
const _hoisted_4 = { class: "hstack gap-2" }
const _hoisted_5 = {
  key: 0,
  class: "hstack gap-2 ms-auto"
}
const _hoisted_6 = ["aria-label"]

import { ref, watch, onMounted } from 'vue';
    import { BTableOptions } from "./BTable.types";
    import PaginationDefault from "@/components/Pagination/PaginationDefault.vue";
    import PaginationNoLastOrTotal from "@/components/Pagination/PaginationNoLastOrTotal.vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BTableHeader',
  props: {
    value: {},
    headerSlotClass: { default: '' },
    currentItemCount: {},
    filters: { default: [] },
    announce: { type: Boolean, default: false },
    navLabel: {}
  },
  emits: ['optionChange'],
  setup(__props: any, { emit: __emit }) {

    const emits = __emit;

    const props = __props;

    var options = ref(props.value as BTableOptions);

    var isNextDisabled = ref(false);

    function handleOptionChange(newOptions){
        options.value = newOptions;
        emits("optionChange", options.value);
    }

    function setNextButtonState(){
        if (props.currentItemCount && options.value) {
            isNextDisabled.value = props.currentItemCount <= options.value.itemsPerPage;
        }
    }

    watch(
    () => props.currentItemCount,
    (val) => {
        setNextButtonState();
    });

    onMounted(() => {
        setNextButtonState();      
    });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(__props.headerSlotClass)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "headerTopBar")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default"),
          (__props.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "pagingStart"),
                _createElementVNode("nav", {
                  "aria-label": __props.navLabel || 'Pagination'
                }, [
                  (__props.value.pagingMode == 'withTotal')
                    ? (_openBlock(), _createBlock(PaginationDefault, {
                        key: 0,
                        "header-slot-class": __props.headerSlotClass,
                        value: __props.value,
                        announce: __props.announce,
                        onOptionChange: handleOptionChange
                      }, null, 8, ["header-slot-class", "value", "announce"]))
                    : (_openBlock(), _createBlock(PaginationNoLastOrTotal, {
                        key: 1,
                        "header-slot-class": __props.headerSlotClass,
                        value: __props.value,
                        "is-previous-disabled": __props.value.page == 1,
                        "is-next-disabled": _unref(isNextDisabled),
                        filters: props.filters,
                        announce: __props.announce,
                        onOptionChange: handleOptionChange,
                        "current-item-count": props.currentItemCount
                      }, null, 8, ["header-slot-class", "value", "is-previous-disabled", "is-next-disabled", "filters", "announce", "current-item-count"]))
                ], 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2)
  ]))
}
}

})